//src/hooks/useGlobalUndoRedo.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setUndoRedoCommand } from '../../../redux/operationSlice';

/**
 * Global undo/redo hook
 *
 * ✅ HOOK TABANLI SİSTEM: Artık direkt undoRedoManager çağırmak yerine
 * Redux'a setUndoRedoCommand('UNDO' | 'REDO') dispatch eder.
 * useUndo ve useRedo hook'ları bu komutları dinler ve işlemleri yapar.
 *
 * @param {THREE.Scene} scene
 * @param {THREE.Camera} camera
 * @param {THREE.Renderer} renderer
 * @param {ChronoUndoRedoManager} undoRedoManagerRef
 */
const useGlobalUndoRedo = (scene, camera, renderer, undoRedoManagerRef) => {
  const dispatch = useDispatch();

  useEffect(() => {
    

    if (!undoRedoManagerRef) {
      
      return;
    }

    const handleKeyDown = (e) => {
      

      if (!undoRedoManagerRef.current) {
        
        return;
      }

      // ✅ Local undo aktifse (capture phase'de local handler çalışmış ve stopPropagation yapmıştır)
      // Bu kontrol artık gereksiz, çünkü local undo stopPropagation yapmalı
      // Ama yine de event.defaultPrevented kontrolü ile double-check yapabiliriz

      // Ctrl+Z → Undo
      if (e.ctrlKey && e.key.toLowerCase() === 'z' && !e.shiftKey) {
        // ✅ Eğer event zaten handle edilmişse (local undo tarafından), atla
        if (e.defaultPrevented) {
          return;
        }
        e.preventDefault();
        dispatch(setUndoRedoCommand('UNDO'));
      }

      // Ctrl+Y → Redo
      if (e.ctrlKey && e.key.toLowerCase() === 'y') {
        if (e.defaultPrevented) {
          return;
        }
        e.preventDefault();
        dispatch(setUndoRedoCommand('REDO'));
      }

      // Ctrl+Shift+Z → Redo (alternatif)
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === 'z') {
        if (e.defaultPrevented) {
          return;
        }
        e.preventDefault();
        dispatch(setUndoRedoCommand('REDO'));
      }
    };

    
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [scene, camera, renderer, undoRedoManagerRef, dispatch]);
};

export default useGlobalUndoRedo;
